import { AlertDialog, Button, ButtonGroup } from '@yaradigitallabs/ahua-react';
import type React from 'react';

type LeaveWithoutConfirmDialogProps = {
  open: boolean;
  onKeepSelecting: () => void;
  onLeavePage: () => void;
};

export const LeaveWithoutConfirmDialog: React.FC<
  LeaveWithoutConfirmDialogProps
> = ({ open, onKeepSelecting, onLeavePage }) => {
  return (
    <AlertDialog
      align="center"
      colorConcept="destructive"
      iconSrc="Bang"
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onKeepSelecting();
        }
      }}
      type="icon"
    >
      <AlertDialog.Content>
        <AlertDialog.Start>
          <AlertDialog.Media
            align="center"
            colorConcept="destructive"
            iconSrc="Bang"
            type="icon"
          />
        </AlertDialog.Start>
        <AlertDialog.Middle>
          <AlertDialog.Title align="center">
            Leave without confirming?
          </AlertDialog.Title>
          <AlertDialog.Description align="center">
            Your selected soft tags won&apos;t be matched until you click
            &quot;Confirm.&quot;
          </AlertDialog.Description>
        </AlertDialog.Middle>
        <AlertDialog.End>
          <ButtonGroup buttonWidth="block" orientation="vertical" size="s">
            <Button onClick={onKeepSelecting}>Keep selecting</Button>
            <Button
              colorConcept="destructive"
              variant="ghost"
              onClick={onLeavePage}
            >
              Leave page
            </Button>
          </ButtonGroup>
        </AlertDialog.End>
      </AlertDialog.Content>
    </AlertDialog>
  );
};
